import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
// Interactive card with hover and click states
const InteractiveCard = React.forwardRef(({ className, children, hover = true, clickable = false, selected = false, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: cn('bg-white dark:bg-gray-800 border rounded-lg shadow-sm transition-all duration-200', {
            'hover:shadow-md hover:scale-[1.02] hover:border-gray-300 dark:hover:border-gray-600': hover,
            'cursor-pointer': clickable,
            'border-blue-500 bg-blue-50 dark:bg-blue-900/20': selected,
            'border-gray-200 dark:border-gray-700': !selected
        }, className), ...props, children: children }));
});
InteractiveCard.displayName = 'InteractiveCard';
const InteractiveCardHeader = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('px-6 py-4 border-b border-gray-200 dark:border-gray-700', className), ...props })));
InteractiveCardHeader.displayName = 'InteractiveCardHeader';
const InteractiveCardTitle = React.forwardRef(({ className, ...props }, ref) => (_jsx("h3", { ref: ref, className: cn('text-lg font-semibold text-gray-900 dark:text-gray-100', className), ...props })));
InteractiveCardTitle.displayName = 'InteractiveCardTitle';
const InteractiveCardContent = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('px-6 py-4', className), ...props })));
InteractiveCardContent.displayName = 'InteractiveCardContent';
export { InteractiveCard, InteractiveCardHeader, InteractiveCardTitle, InteractiveCardContent };
